import { render, staticRenderFns } from "./Detalle-compra.vue?vue&type=template&id=8161a014"
import script from "./Detalle-compra.vue?vue&type=script&lang=js"
export * from "./Detalle-compra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports